
import VueResource from 'vue-resource';
var _vue = {};
function _Http(opts){
    var Http = this.$http || _vue.http;
    if(opts.url.indexOf('?')>=0){
        opts.url += "&_t="+new Date().getTime();
    }else{
        opts.url += "?_t="+new Date().getTime();
    }
    Http(opts).then(res => {
        // console.log("Http",res);
        if(res.body.result || opts.savefile){
            // 保存文件
            if(opts.savefile && typeof res.body == 'string'){
                var fileName = this.decode(res.headers.map.name[0])
                var blob =new Blob([res.body], {type:'application/octet-stream'})
                if(window.navigator.msSaveBlob){//msSaveOrOpenBlob方法返回bool值
                    navigator.msSaveBlob(blob, fileName);//本地保存
                } else {
                    var link = document.createElement('a');//a标签下载
                    link.href = window.URL.createObjectURL(blob);
                    link.download = fileName;
                    link.click();
                    window.URL.revokeObjectURL(link.href);
                }
            }
            opts.success && opts.success(res.body);
        }else{
            opts.error && opts.error(res.body);  
            console.log("error",res); 
        }
        opts.complete && opts.complete(res.body || res);
    }).catch(res => {
        console.log("Exception",res);
        // if(opts.reqCount<2){
        //     opts.reqCount++;
        //     _Http.call(this,opts);
        // }else{
        //     opts.error && opts.error(res);
        //     opts.complete && opts.complete(res);
        // }
    });
}
function _http(opts){
    opts.async = true;
    opts.timeout = opts.timeout || 20000000;
    _Http.call(this,opts);
}

function Get(url,opts){
    if(typeof url == "object"){
        opts = url;
        url = opts.url;
    }
    opts = opts || {};
    opts.url = url;
    opts.method = "get";
    opts.reqCount = 0;
    opts.data = opts.data || {};
    // 語言
    if (this.sessionGetItem('Language') === '2') {
        opts.data.language = 'zh_hk'
    } else if (this.sessionGetItem('Language') === '3') {
        opts.data.language = 'zh_cn'
    } else {
        opts.data.language = 'eng'
    }
    opts.params = opts.data;
    _http.call(this,opts);
}

function Post(url,opts){
    if(typeof url == "object"){
        opts = url;
        url = opts.url;
    }
    opts = opts || {};
    opts.url = url;
    opts.emulateJSON = true;
    opts.method = "post";
    opts.data = opts.data || {};
    // 語言
    if (this.sessionGetItem('Language') === '2') {
        opts.data.language = 'zh_hk'
    } else if (this.sessionGetItem('Language') === '3') {
        opts.data.language = 'zh_cn'
    } else {
        opts.data.language = 'eng'
    }
    opts.body = opts.data;
    opts.reqCount = 0;
    delete opts.data;
    _http.call(this,opts);
}

function PostStream(url,opts){
    if(typeof url == "object"){
        opts = url;
        url = opts.url;
    }
    opts = opts || {};
    opts.data = opts.data || {};
    // 語言
    if (this.sessionGetItem('Language') === '2') {
        opts.data.language = 'zh_hk'
    } else if (this.sessionGetItem('Language') === '3') {
        opts.data.language = 'zh_cn'
    } else {
        opts.data.language = 'eng'
    }
    if(typeof opts.data == "object"){
        opts.data = JSON.stringify(opts.data);
    }
    opts.url = url;
    opts.reqCount = 0;
    opts.method = "post";
    opts.body = opts.data;
    opts.headers = { "Content-Type": 'application/json;charset=utf-8' };
    delete opts.data;
    _http.call(this,opts);
}

function Post_notlanguage (url,opts) {
    if(typeof url == "object"){
        opts = url;
        url = opts.url;
    }
    opts = opts || {};
    opts.data = opts.data || {};
    
    if(typeof opts.data == "object"){
        opts.data = JSON.stringify(opts.data);
    }
    opts.url = url;
    opts.reqCount = 0;
    opts.method = "post";
    opts.body = opts.data;
    opts.headers = { "Content-Type": 'application/json;charset=utf-8' };
    delete opts.data;
    _http.call(this,opts);
}

function PostForm(url,opts){
    if(typeof url == "object"){
        opts = url;
        url = opts.url;
    }
    opts = opts || {};
    var formData = new FormData();

    for(var key in opts.data){
        if (key != 'file') {
            formData.append(key, opts.data[key]);
        }else{
            // 文件
            if (opts.data.file.length > 0) {
                // 多个文件 数组存放文件形式传入
                for(var i=0; i < opts.data.file.length; i++){
                    formData.append('file', opts.data.file[i]);
                }
            }else{
                // 单个文件 直接传入文件
                formData.append('file', opts.data.file);
            }
        }
    }
    console.log("@@@@@@@@@@")
    console.log(formData)
    // 語言
    if (this.sessionGetItem('Language') === '2') {
        formData.append('language', 'zh_hk');
    } else if (this.sessionGetItem('Language') === '3') {
        formData.append('language', 'zh_cn');
    } else {
        formData.append('language', 'eng');
    }
    if(typeof opts.data == "object"){
        opts.data = JSON.stringify(opts.data);
    }
    opts.body = formData
    opts.url = url;
    opts.reqCount = 0;
    opts.method = "post";
    opts.headers = { "Content-Type": 'multipart/form-data' };
    delete opts.data;
    _http.call(this,opts);
}

//初始化插件
function plugin(Vue){
    if(plugin.installed){
        return;
    }
    _vue = Vue;

    // 引入resource插件
    Vue.use(VueResource);

    Vue.get = Get;
    Vue.post = Post;
    Vue.postStream = PostStream;
    Vue.postForm = PostForm;
    Vue.post_notlanguage = Post_notlanguage;

    Object.defineProperties(Vue.prototype, {
        $get:{
            get:function get(){
                return Get;
            }
        },
        $post:{
            get:function get(){
                return Post;
            }
        },
        $postStream:{
            get:function get(){
                return PostStream;
            }
        },
        $postForm:{
            get:function get(){
                return PostForm;
            }
        },
        $post_notlanguage:{
            get:function get(){
                return Post_notlanguage;
            }
        }
    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

plugin.get = Get;
plugin.post = Post;
plugin.postStream = PostStream;
plugin.postForm = PostForm;
plugin.post_notlanguage = Post_notlanguage;


 export default plugin;



// WEBPACK FOOTER //
// ./src/util/ajax.js